import { getMessages } from '../../../../../../store/constants';

export const SNACKBAR_ID_CHECKLIST_DELETE = 'SNACKBAR_ID_CHECKLIST_DELETE';
export const SNACKBAR_CHECKLIST_DELETE = getMessages().getText('snackbar.checklist.delete');
